import { render, staticRenderFns } from "./HeaderDeAprovarContasAPagar.vue?vue&type=template&id=3f0f122e&scoped=true"
import script from "./HeaderDeAprovarContasAPagar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderDeAprovarContasAPagar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderDeAprovarContasAPagar.vue?vue&type=style&index=0&id=3f0f122e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f122e",
  null
  
)

export default component.exports